import calcRandomNumberWithMax from "../../../objects/CommonUse/calc_random_number_with_max";
import replaceTextInString from "../../../objects/CommonUse/replace_text_in_string";
import { determinePossiblePurchases } from "./determine_possible_purchases";
import EventImageList from "../datasets/event_image_list";

export const determineImageURL = (currentCard, itemArr, backgroundName, purchaseArr) => {
    let cardImageObj={};
    let imageDirArr = [];
    if (currentCard.imageDir && currentCard.imageDir.length > 0){
        imageDirArr = currentCard.imageDir.split('-');
    }
    let purchaseItem = false;
    let pictureError = "";

    //  this adds the image of the funStuff item
    if (imageDirArr[0] === "funStuff") {
        let funStuffCategory = imageDirArr[1];
        const funStuffItem = itemArr.find(elem => elem.category === funStuffCategory);
        let cardImageURL = "";
        let imageClass = "";
        let imageName = "";
        if (!funStuffItem){
            cardImageURL = "/assets/UnlockedFeatures/blank.png";
            imageClass = "mx-auto d-block friend-game-img"
        }else{
            cardImageURL = "/assets/" + funStuffItem.pictureURL;
            imageClass = "mx-auto d-block funstuff-game-img ";
            imageName = funStuffItem.name;
        }
            const imagePosition = "funStuff-position";
            let imageNamePosition = "funStuff-name-style decorative";
            if (funStuffCategory === "Cat"){
                imageNamePosition = imageNamePosition + " funStuff-name-position-cat";
            }else{
                imageNamePosition = imageNamePosition + " funStuff-name-position";
            }
            cardImageObj = {cardImageURL: cardImageURL,
                imagePosition: imagePosition, imageClass: imageClass, imageName: imageName, 
                imageNamePosition: imageNamePosition, cardImage: true, cardImageType: "funStuff",
                purchaseItem: purchaseItem
            };
              
    // this adds the image defined by the image list on the card (such as friendArr)
    } else {
        if (currentCard.imageDir  && currentCard.imageDir.length > 0){
            let itemObj =  EventImageList.find(elem => elem.imageDir === currentCard.imageDir);
            let itemURL = "";
            let itemName = "";
            // the following supports purchase items
            if (imageDirArr[0] === "item"){
                purchaseItem = true;
                if (!purchaseArr){
                    purchaseArr = [];
                }
                let possiblePurchases = determinePossiblePurchases(purchaseArr, currentCard.imageDir);
                let itemIndx = 0
                if (possiblePurchases.length > 1){
                    const nbrItems = possiblePurchases.length;
                    itemIndx = calcRandomNumberWithMax(nbrItems, true);
                    if (!possiblePurchases[itemIndx]){
                        itemIndx = 0;
                    }
                }
                //  the "thingAMaJig" option is a work-around and can be eliminated if there are 
                //  no "no-purchase condition is missing" errors in errorlog
                if (possiblePurchases.length === 0 || possiblePurchases[itemIndx].itemName === ""){
                    itemName="thingamajig";
                    itemURL = "./assets/Events/thingamajig.png";
                    pictureError = "no-purchase condition is missing " + currentCard.imageDir;
                }else{
                    itemName = possiblePurchases[itemIndx].itemName;
                    itemURL = "./assets/Events/" + possiblePurchases[itemIndx].imageURL;
                }
                                        
                const replaceObj = {string: itemName};
                currentCard.description = 
                    replaceTextInString(currentCard.description, replaceObj, "itemName", "string");
   
            }else{
                //  the following supports cards that use an image table other than purchase items 
                // (ex: puppies)
                let itemIndx = 0
                if (itemObj.options.length > 1){
                    const nbrItems = itemObj.options.length;
                    itemIndx = calcRandomNumberWithMax(nbrItems, true);
                }
                itemURL = "./assets/Events/" + itemObj.options[itemIndx].imageURL;
            }
            let imagePosition = "other-image-position";
            const imageClass = "mx-auto d-block other-image-size";
            cardImageObj = { cardImageURL: itemURL, imagePosition: imagePosition, imageClass: imageClass,
                itemName: itemName, cardImage: true, cardImageType: "otherImage", purchaseItem: purchaseItem,
                pictureError: pictureError};

        // this adds the image for a pet (if there is one) to the living room
        }else{
            if (backgroundName === "home" && itemArr){
                for (let i=0; i<itemArr.length; i++){
                    if (itemArr[i].levelName === "Adopt a Pet"){
                        const pictureURL = itemArr[i].pictureURL;
                        const startPos = pictureURL.length - 4;
                        const petURL = pictureURL.substr(0,startPos);
                        const cardImageURL = "./assets/" + petURL + "LyingDown.png";
                        let imageClass = "pet-game-img";
                        if (itemArr[i].category === "Cat"){
                             imageClass = "pet-game-img-cat";
                        }
                        const imagePosition = "pet-position";
                        cardImageObj = {cardImageURL: cardImageURL, 
                            imagePosition: imagePosition, 
                            imageClass: imageClass, 
                            cardImage: true, 
                            cardImageType: "funStuff", 
                            purchaseItem: purchaseItem};
                        break;
                    }
                }
            }else{
                cardImageObj = {cardImage: false};
            }
        }
    }           
    return cardImageObj;
   
}
export default determineImageURL;

